import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
//
import { varFadeInUp } from './variants';

const TextAnimate = ({ text, variants, sx, ...other }) => (
  <Typography
    component={motion.h1}
    sx={{
      typography: 'h1',
      overflow: 'hidden',
      display: 'inline-flex',
      ...sx
    }}
    {...other}
  >
    {text.split('').map((letter, index) => (
      <motion.span key={index} variants={variants || varFadeInUp}>
        {letter}
      </motion.span>
    ))}
  </Typography>
);

TextAnimate.propTypes = {
  text: PropTypes.string,
  variants: PropTypes.object,
  sx: PropTypes.object
};

export default TextAnimate;
